import axios from 'axios';
import getImageMatcherBaseUrl from './imageMatcherUrl';

import { configureHttpHeaders, onSuccess, onError, onErrorUnmatched } from './apiHelpers';

const baseUrl = getImageMatcherBaseUrl();
function post(postUrl, postData) {
  return axios({
    method: 'post',
    url: `${baseUrl}${postUrl}`,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}

function postUnmatched(postUrl, postData) {
  return axios({
    method: 'post',
    url: `${baseUrl}${postUrl}`,
    data: postData,
  })
    .then(onSuccess)
    .catch(onErrorUnmatched);
}

function put(putUrl, putData) {
  return axios({
    method: 'put',
    url: `${baseUrl}${putUrl}`,
    data: putData,
  })
    .then(onSuccess)
    .catch(onError);
}

function deleteDoc(postUrl, postData) {
  return axios({
    method: 'delete',
    url: `${baseUrl}${postUrl}`,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}

export function submitRespondToIssuer(respondIssuerObject, caseNumber) {
  const Url = `api/v1/cases/${caseNumber}/response/issuer`;
  configureHttpHeaders(axios);
  return post(`${Url}`, respondIssuerObject);
}

export function saveDocumentWithCaseDetails(responseDetails) {
  let Url = `api/v1/document/create`;
  configureHttpHeaders(axios);
  return postUnmatched(`${Url}`, responseDetails);
}

export function submitUnlinkImages(documentId, pageIndices) {
  const Url = `api/v1/unlinker/case/document`;
  configureHttpHeaders(axios);
  return put(`${Url}`, {
    documentId,
    pageIndex: pageIndices,
  });
}

export function archiveNonDimsImage(documentId) {
  configureHttpHeaders(axios);
  const Url = `api/v1/match/image/archive/sdm`;
  return put(`${Url}`, {
    documentId,
  });
}

export function uploadDocument(newfile, acquirerCode) {
  const Url = `api/v1/upload-doc/upload?acquirerCode=${acquirerCode}`;
  let data = new FormData();
  data.append('multipartDoc', newfile);
  configureHttpHeaders(axios);
  return post(`${Url}`, data);
}

export function deleteDocument(fileName) {
  const Url = `api/v1/upload-doc/delete`;
  let data = new FormData();
  data.append('documentName', fileName);
  configureHttpHeaders(axios);
  return deleteDoc(`${Url}`, data);
}


export function attachDocuments(fileData, caseNumber, caseStageId, acquirerCode) {
  const Url = `api/v1/upload-doc/attach/case/${caseNumber}/stage/${caseStageId}?cardBrandCode=${fileData.cardBrandCode}&regionCode=${fileData.regionCode}&uploadSource=DIMS&acquirerCode=${acquirerCode}`;
  let data = new FormData();
  data.append('documentUpload', fileData.uploadFileList);
  configureHttpHeaders(axios);
  return post(`${Url}`, fileData.uploadFileList);
}

export function uploadImportDocument(newfile, userId, acquirerCode, region) {
  const url = `api/v1/upload-doc/upload/file?acquirerCode=${acquirerCode}&regionCode=${region}&userId=${userId}`;
  let data = new FormData();
  data.append('multipartDoc', newfile);
  configureHttpHeaders(axios);

  return post(url, data);
}
